// extracted by mini-css-extract-plugin
export default {"logoContainer":"profile-logo-module__logoContainer___sUKqn","logoImage":"profile-logo-module__logoImage___pjwzX"};